import { render, staticRenderFns } from "./JobInfo.vue?vue&type=template&id=5b179150&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"
import style0 from "./JobInfo.vue?vue&type=style&index=0&id=5b179150&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b179150",
  null
  
)

export default component.exports